<template>
  <div class="topnavbar">
    <b-navbar toggleable="lg">
      <b-navbar-brand href="#">{{ $route.meta.title }}</b-navbar-brand>
      <b-navbar-toggle target="nav_collapse" />
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <template slot="button-content">{{this.$session.get("username")}} </template>
            <b-dropdown-item href="/dashboard">Home</b-dropdown-item>
            <b-dropdown-item href="/profile">Profile</b-dropdown-item>
            <b-dropdown-item href="" @click="closesocket">Logout</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  export default {
    name: 'TopNavbar',
    data() {
      return{
      }},
      methods:{
        ...mapActions([
       'commitactivetab_actions',
       'send_actions',
       'connect_actions',
       'disconnect_actions',
       'tickleConnection_actions',
       'commitisLoading'
      ]),
       closesocket: function() {
        
        var msg={
                message:"logout",
                url:"/app/chatlist"
              }
              this.commitisLoading(true)
              this.send_actions(msg)
              var myTimerPromise = new Promise((resolve, reject) => {
              setTimeout(() => {
                  this.disconnect_actions()
                  resolve();
              }, 50); 
              });
              
              
              var myTimerPromise = new Promise((resolve, reject) => {
              setTimeout(() => {
                  this.commitisLoading(false)
                  this.$router.push({ name: 'logout'})
                  resolve();
              }, 1000); 
      });
              
      }
      },
      computed: {
        ...mapGetters([
          'getseenmessage'
        ])
      },
    created() {
    }

      
    }
  </script>
  <style>
  .topnavbar{
    position:relative;
    font-size: 16px;
    background-color: #ffff;
    z-index:2;
    display: block;
    background-color: hsla(0,0%,100%,.96);
    border-bottom: 1px solid #dee2e6;
  }
  .topnavbar .navbar{
    padding: 10px 25px;
  }

  .topnavbar .navbar-light .navbar-brand {
    color: #888;
    font-weight: 300;
    font-size: 19px;
  }
  
</style>